// extracted by mini-css-extract-plugin
module.exports = {"spacing":"48px","break-small":"375px","badge":"styles_badge__2WMo4"};